import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { Children } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

type BreadcrumbProps = PropsWithChildren<{
  className?: string;
  showBackButtonIcon?: boolean;
  backButtonLabel?: string;
}>;

function Breadcrumb({
  children,
  className,
  showBackButtonIcon = true,
  backButtonLabel,
}: BreadcrumbProps) {
  const navigate = useNavigate();
  return (
    <nav
      className={classNames(styles.breadcrumb, className)}
      aria-label="breadcrumb"
    >
      <ol>
        {showBackButtonIcon && <FontAwesomeIcon icon={faAngleLeft} size="lg" />}
        {backButtonLabel && (
          <>
            <button onClick={() => navigate(-1)}>
              <span className={styles.backBreadcrumbItem}>
                {backButtonLabel}
              </span>
            </button>
            <li aria-hidden aria-label="separator" className={styles.separator}>
              /
            </li>
          </>
        )}

        {Children.map(children, (child, index) => (
          <>
            {index > 0 && (
              <li
                aria-hidden
                aria-label="separator"
                className={styles.separator}
              >
                /
              </li>
            )}
            <li>{child}</li>
          </>
        ))}
      </ol>
    </nav>
  );
}

export { Breadcrumb };
